import "./App.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import Result from "./pages/Result/Result";
import NewCase from "./pages/NewCase/NewCase";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Dashboard />} />
				<Route path="/add-new-case" element={<NewCase />} />
				<Route path="/case-details/:caseNumber" element={<Result />} />
			</Routes>
		</Router>
	);
}

export default App;
